/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable react/no-unescaped-entities */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { isEmpty, pick, get } from 'lodash';
import numeral from 'numeral';

import BenchmarkModal from './Modal';
import { extractFilterValues } from '../../utils/filters';

const BenchmarkBar = ({
  metricA,
  metricB,
  metricC,
  metricD,
  titlesCount,
  benchmarkTitle,
  filters,
  onSave,
  applyBenchmarkFilters,
  selectBenchmark,
  appliedBenchmark,
  benchmarks,
  loading,
  displayBenchmarkTooltip,
  setDisplayBenchmarkTooltip,
  contentType
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [editBenchmark, setEditBenchmark] = useState(null);
  const [
    dontShowBenchMarkTooltipAgain,
    setDontShowBenchMarkTooltipAgain
  ] = useState(false);
  const [displayBenchmarkTitle, setDisplayBenchmarkTitle] = useState(
    get(appliedBenchmark, 'name', benchmarkTitle)
  );

  const onClickOptions = e => {
    setOpenModal(true);
    setEditBenchmark(null);
  };
  const handleClose = () => {
    setOpenModal(false);
    setEditBenchmark(null);
  };

  const handleApply = (activeFilters, title, uuid) => {
    const final = {};
    // eslint-disable-next-line no-return-assign
    activeFilters.forEach(f => (final[f.id] = f));
    setDisplayBenchmarkTitle(title);
    setOpenModal(false);
    selectBenchmark(uuid);
    return applyBenchmarkFilters(final, uuid);
  };

  const showEditBenchmark = () => {
    if (appliedBenchmark) {
      setEditBenchmark(appliedBenchmark);
    }
    setOpenModal(true);
  };

  const handleSave = async (id, n, filts, isDefault) => {
    const activeFilters = filts
      .filter(({ value }) => !isEmpty(value))
      .map(f =>
        pick(f, [
          'value',
          'id',
          'isAsync',
          'isMulti',
          'label',
          'title',
          'value'
        ])
      );

    const response = await onSave(id, n, JSON.stringify(activeFilters), {
      isBenchmark: true,
      isDefault
    });
    if (!response) {
      return null;
    }

    setOpenModal(false);

    handleApply(activeFilters, n, response.uuid);
  };

  const displayMetric = metric =>
    loading && (metric === '--' || metric === null) ? (
      <div className="tvt-benchmark__metric-loading-state" />
    ) : (
      metric
    );

  const displayShowsCount = count =>
    loading && (count === '--' || count === 'Shows') ? (
      <div className="tvt-benchmark__show-count-loading-state" />
    ) : (
      <>
        <div>{titlesCount}</div>
        <div>{contentType === 'series' ? 'Shows' : 'Movies'}</div>
      </>
    );

  const displayVariance = variance => {
    let className = 'tvt-show-detail__benchmark-bar-top-variance ';
    if (Number(variance) > 0) {
      className += 'benchmark-positive';
    } else if (Number(variance) < 0) {
      className += 'benchmark-negative';
    }

    const formattedVariance = numeral(variance).format(0.0);
    return variance ? (
      <OverlayTrigger
        placement="right"
        overlay={
          <Tooltip id="benchmark-bar__item-tooltip">
            Percentage Difference - Measures the percentage difference between
            the target title and the benchmark segment. It is calculated as
            [(title# - benchmark#)/title#].
          </Tooltip>
        }
      >
        <div className={className}>
          {`${Number(variance) > 0 ? '+' : ''}${formattedVariance}%`}
        </div>
      </OverlayTrigger>
    ) : null;
  };

  const benchMarkOptionsButton = () => (
    <button className="benchmark-options-button" onClick={onClickOptions}>
      <FontAwesomeIcon
        className="benchmark-options-button-icon"
        icon="sliders-h"
        size="1x"
      />
    </button>
  );

  const onClickExitBenchmarkTooltip = () => {
    setDisplayBenchmarkTooltip(!displayBenchmarkTooltip);
  };

  const onClickDontShowBenchmarkTooltip = () => {
    setDontShowBenchMarkTooltipAgain(!dontShowBenchMarkTooltipAgain);
  };

  const onClickGotItBenchmarkTooltip = () => {
    if (dontShowBenchMarkTooltipAgain) {
      localStorage.setItem('showBenchmarkTooltip', false);
    }

    setDisplayBenchmarkTooltip(false);
  };

  useEffect(() => {
    if (
      appliedBenchmark &&
      appliedBenchmark.name &&
      appliedBenchmark.name !== displayBenchmarkTitle
    ) {
      setDisplayBenchmarkTitle(appliedBenchmark.name);
    }
  }, [appliedBenchmark, benchmarks, displayBenchmarkTitle]);

  return (
    <div className="tvt-show-detail__benchmark-bar-wrapper">
      <BenchmarkModal
        handleClose={handleClose}
        isOpen={openModal}
        filtersConfig={filters.config}
        handleSave={handleSave}
        handleApply={handleApply}
        appliedBenchmark={appliedBenchmark}
        editingBenchmark={editBenchmark}
        contentType={contentType}
      />
      <div className="tvt-show-detail__benchmark-bar-top">
        <div className="tvt-show-detail__benchmark-bar-box benchmark-box-1" />
        <div className="tvt-show-detail__benchmark-bar-box benchmark-box-2">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="benchmark-bar__item-tooltip">
                {metricA.tooltip}
              </Tooltip>
            }
          >
            <div className="tvt-show-detail__benchmark-bar-top-label">
              {metricA.label}
            </div>
          </OverlayTrigger>
          <div className="tvt-show-detail__benchmark-bar-top-value">
            {displayMetric(metricA.top)}
          </div>
          {displayVariance(metricA.variance)}
        </div>
        <div className="tvt-show-detail__benchmark-bar-box benchmark-box-3">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="benchmark-bar__item-tooltip">
                {metricB.tooltip}
              </Tooltip>
            }
          >
            <div className="tvt-show-detail__benchmark-bar-top-label">
              {metricB.label}
            </div>
          </OverlayTrigger>

          <div className="tvt-show-detail__benchmark-bar-top-value">
            {displayMetric(metricB.top)}
          </div>
          {displayVariance(metricB.variance)}
        </div>
        {metricC.hide ? null : (
          <div className="tvt-show-detail__benchmark-bar-box benchmark-box-4">
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="benchmark-bar__item-tooltip">
                  {metricC.tooltip}
                </Tooltip>
              }
            >
              <div className="tvt-show-detail__benchmark-bar-top-label">
                {metricC.label}
              </div>
            </OverlayTrigger>
            <div className="tvt-show-detail__benchmark-bar-top-value">
              {displayMetric(metricC.top)}
            </div>
            {displayVariance(metricC.variance)}
          </div>
        )}

        {metricD.hide ? null : (
          <div className="tvt-show-detail__benchmark-bar-box benchmark-box-5">
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip id="benchmark-bar__item-tooltip">
                  {metricD.tooltip}
                </Tooltip>
              }
            >
              <div className="tvt-show-detail__benchmark-bar-top-label">
                {metricD.label}
              </div>
            </OverlayTrigger>
            <div className="tvt-show-detail__benchmark-bar-top-value">
              {displayMetric(metricD.top)}
            </div>
            {displayVariance(metricD.variance)}
          </div>
        )}
        <div className="tvt-show-detail__benchmark-bar-box benchmark-box-6 benchmark-tooltip">
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="benchmark-bar__item-tooltip">
                <div>
                  This Score Bar highlights key{' '}
                  {contentType === 'series' ? 'Show' : 'Movie'} metrics (top
                  values) and benchmarks them against metrics from a defined
                  Benchmark Segment (bottom values). The default Benchmark
                  Segment is Similar{' '}
                  {contentType === 'series' ? 'Shows' : 'Movies'}.
                </div>
                <div>
                  To configure your own Benchmark Segment, click the button to
                  the left of the Benchmark name. Applying a Custom Benchmark
                  with demographic or date filters will override any
                  corresponding page filters for the Benchmark (bottom) values
                  in the Score Bar.{' '}
                </div>
                <div>
                  Click the name of a Custom Benchmark Segment in the Score Bar
                  to see details for that segment.
                </div>
              </Tooltip>
            }
          >
            <FontAwesomeIcon
              className="benchmark-info-icon"
              size="1x"
              icon="info-circle"
            />
          </OverlayTrigger>
        </div>
      </div>
      <div className="tvt-show-detail__benchmark-bar-bottom">
        <div className="tvt-show-detail__benchmark-bar-box benchmark-box-1">
          {get(extractFilterValues(filters.fields), 'length', 0) > 1 &&
          displayBenchmarkTooltip ? (
            <div id="tvt-benchmark__first-time-user-tooltip">
              <div className="tvt-benchmark__first-time-user-tooltip-banner-title">
                <FontAwesomeIcon
                  className="benchmark-lightbulb-icon"
                  size="1x"
                  icon="lightbulb"
                />
                Benchmark Score Bar
                <button
                  className="benchmark-options-button"
                  onClick={onClickExitBenchmarkTooltip}
                >
                  <FontAwesomeIcon
                    className="benchmark-tooltip-exit-button-icon"
                    icon="times"
                    size="1x"
                  />
                </button>
              </div>
              <div className="tvt-benchmark__first-time-user-tooltip-info">
                <div>
                  Benchmark values in the bottom half of this Score Bar do not
                  reflect page level filters.
                </div>
                <div>
                  To configure Benchmark Segment, click the sliders icon.
                </div>
              </div>
              <div className="tvt-benchmark__first-time-user-tooltip-footer">
                <button onClick={onClickGotItBenchmarkTooltip}>GOT IT</button>
                <label className="tvt-benchmark__default-checkbox">
                  Do not show again
                  <input
                    id="tvt-benchmark__default-checkbox-input"
                    type="checkbox"
                    defaultChecked={dontShowBenchMarkTooltipAgain}
                    onChange={onClickDontShowBenchmarkTooltip}
                  />
                  <span className="checkmark" />
                </label>
              </div>
            </div>
          ) : null}
          {benchMarkOptionsButton()}
          <button
            disabled={!appliedBenchmark}
            onClick={showEditBenchmark}
            className="benchmark-segment-button"
          >
            {!appliedBenchmark ? (
              <OverlayTrigger
                placement="bottom"
                overlay={
                  <Tooltip id="benchmark-bar__item-tooltip">
                    <div>
                      The default benchmark{' '}
                      {contentType === 'series'
                        ? '‘Similar Series’'
                        : '‘Similar Movies’'}{' '}
                      compares a title to other{' '}
                      {contentType === 'series' ? 'shows' : 'movies'} with a
                      similar tier of followers. This tier is determined by the
                      global, unfiltered follower count of a{' '}
                      {contentType === 'series' ? 'show' : 'movie'}.
                    </div>
                    <div>
                      A particular title will fall into one of the following
                      tiers:
                      <div>500 - 1,000 followers</div>
                      <div>1,000 - 10,000 followers</div>
                      <div>10,000 - 50,000 followers</div>
                      <div>50,000 - 100,000 followers</div>
                      <div>100,000 - 500,000 followers</div>
                      <div>500,000+ followers</div>
                    </div>
                  </Tooltip>
                }
              >
                <div>{displayBenchmarkTitle}</div>
              </OverlayTrigger>
            ) : (
              displayBenchmarkTitle
            )}
          </button>
        </div>
        <div className="tvt-show-detail__benchmark-bar-box benchmark-box-2">
          <div className="tvt-show-detail__benchmark-bar-bottom-value">
            {displayMetric(metricA.bottom)}
          </div>
        </div>
        <div className="tvt-show-detail__benchmark-bar-box benchmark-box-3">
          <div className="tvt-show-detail__benchmark-bar-bottom-value">
            {displayMetric(metricB.bottom)}
          </div>
        </div>
        {metricC.hide ? null : (
          <div className="tvt-show-detail__benchmark-bar-box benchmark-box-4">
            <div className="tvt-show-detail__benchmark-bar-bottom-value">
              {displayMetric(metricC.bottom)}
            </div>
          </div>
        )}
        {metricD.hide ? null : (
          <div className="tvt-show-detail__benchmark-bar-box benchmark-box-5">
            <div className="tvt-show-detail__benchmark-bar-bottom-value">
              {displayMetric(metricD.bottom)}
            </div>
          </div>
        )}
        <div className="tvt-show-detail__benchmark-bar-box benchmark-box-6">
          {displayShowsCount(titlesCount)}
        </div>
      </div>
    </div>
  );
};

const MetricType = {
  label: PropTypes.string,
  tooltip: PropTypes.string,
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  hide: PropTypes.bool
};

const DefaultMetric = {
  label: '',
  tooltip: '',
  top: '--',
  bottom: '--',
  variance: null,
  hide: false
};

BenchmarkBar.propTypes = {
  metricA: PropTypes.shape(MetricType),
  metricB: PropTypes.shape(MetricType),
  metricC: PropTypes.shape(MetricType),
  metricD: PropTypes.shape(MetricType),
  titlesCount: PropTypes.string.isRequired,
  benchmarkTitle: PropTypes.string,
  filters: PropTypes.shape({
    config: PropTypes.shape({}),
    fields: PropTypes.shape({})
  }),
  selectBenchmark: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  applyBenchmarkFilters: PropTypes.func.isRequired,
  appliedBenchmark: PropTypes.shape({
    filters: PropTypes.string
  }),
  benchmarks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  loading: PropTypes.bool.isRequired,
  displayBenchmarkTooltip: PropTypes.bool.isRequired,
  setDisplayBenchmarkTooltip: PropTypes.bool.isRequired,
  contentType: PropTypes.string
};

BenchmarkBar.defaultProps = {
  benchmarkTitle: 'Similar Shows',
  filters: { config: {} },
  appliedBenchmark: {},
  metricA: DefaultMetric,
  metricB: DefaultMetric,
  metricC: DefaultMetric,
  metricD: DefaultMetric,
  contentType: 'series'
};

export default BenchmarkBar;
